import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["postCode", "prefecture", "city", "address"]
  static values = { id: Number }

  connect() { }

  lookup() {
    const zip = this.postCodeTarget.value.replace("-", "").trim()
    if (!zip.match(/^\d{7}$/)) return

    fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`)
      .then(response => response.json())
      .then(data => {
        if (data.results && data.results[0]) {
          const result = data.results[0]

          this.prefectureTarget.value = result.prefcode
          this.cityTarget.value = result.address2
          this.addressTarget.value = result.address3
          if (this.hasAreaTarget) this.updateAreas()
        } else {
        }
      })
      .catch((e) => {
        alert(e)
      })
  }
}